import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    const preferedLanguageCode = localStorage.getItem('preferedLanguageCode') || 'en';
    this.translate.use(preferedLanguageCode);
  }
}
